// src/axiosInstance.js
import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const attachAxiosInterceptors = (
  refreshAuthToken,
  logout,
  openAuthDrawer
) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      console.log("attachAxiosInterceptors invoked");

      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const newAccessToken = await refreshAuthToken();
          axiosInstance.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          if (logout) logout();
          if (openAuthDrawer) {
            openAuthDrawer("Session expired. Please log in again");
          }
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
};
